export default __webpack_public_path__ + "images/assets/9f289f8f3edca3c2603c21c3b99592db.svg";